import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/main.css';
import App from './App';
import './i18n';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// scripts/build/prerender.js stamps data-prerendered="true" on this element after
// writing real, route-specific markup into it -- checked as an explicit
// marker rather than rootElement.hasChildNodes(), which could false-positive
// on stray/service nodes. When present, attach with hydrateRoot() so React
// reconciles against the existing DOM instead of createRoot() discarding it
// and rendering fresh (which would erase the pre-JS content advantage and
// cause a visible flash on every load, prerendered or not).
if (rootElement.dataset.prerendered === 'true') {
  // Sprint 8.2: a small, permanent, always-on status object -- not the
  // heavier MutationObserver/HTML-capture instrumentation used to find the
  // original hydration mismatches (see scripts/debug/debug-hydration.js for
  // that; it's a standalone research tool, not wired into this file). This is
  // just enough for scripts/verify/verify-hydration.js to assert, against the real
  // production build, that every prerendered route hydrates cleanly:
  // hydrateRoot() never calls onRecoverableError, so React never discards
  // and re-renders (see the react-dom source: onRecoverableError only fires
  // when the initial hydration attempt didn't match the existing DOM).
  window.__HYDRATION_STATUS__ = { started: true, completed: false, recovered: false, errors: [] };
  ReactDOM.hydrateRoot(rootElement, app, {
    onRecoverableError(error, errorInfo) {
      window.__HYDRATION_STATUS__.recovered = true;
      window.__HYDRATION_STATUS__.errors.push({
        message: error?.message,
        componentStack: errorInfo?.componentStack,
      });
    },
  });
  window.__HYDRATION_STATUS__.completed = true;
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
